// frontend/modules/customer-notification/components/dashboard/NotificationMetrics.tsx
import React from 'react';
import { Card, Row, Col, Statistic, Tooltip, Spin } from 'antd';
import { 
    CheckCircleOutlined, 
    CloseCircleOutlined, 
    MessageOutlined,
    ClockCircleOutlined
} from '@ant-design/icons';
import { NotificationStatistics } from '@/shared/api/model';

interface NotificationMetricsProps {
    statistics: NotificationStatistics | null;
    isLoading: boolean;
}

const NotificationMetrics: React.FC<NotificationMetricsProps> = ({ statistics, isLoading }) => {
    const getSuccessRate = () => {
        if (!statistics) return 0;
        
        const total = statistics.totalNotifications||0;
        const success = statistics.successfulNotifications||0;
        
        return total > 0 ? Math.round((success / total) * 100) : 0;
    };
    
    return (
        <Card title="Notification Metrics" className="mb-4">
            {isLoading ? (
                <div className="flex justify-center items-center h-32">
                    <Spin size="large" />
                </div>
            ) : (
                <Row gutter={16}>
                    <Col xs={12} sm={12} md={6}>
                        <Tooltip title="Total notifications sent in the selected period">
                            <Statistic 
                                title="Total Sent" 
                                value={statistics?.totalNotifications || 0} 
                                prefix={<MessageOutlined />} 
                            />
                        </Tooltip>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                        <Tooltip title="Successfully delivered notifications">
                            <Statistic 
                                title="Delivered" 
                                value={statistics?.successfulNotifications || 0} 
                                valueStyle={{ color: '#3f8600' }}
                                prefix={<CheckCircleOutlined />} 
                            />
                        </Tooltip>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                        <Tooltip title="Failed notifications">
                            <Statistic 
                                title="Failed" 
                                value={statistics?.failedNotifications || 0} 
                                valueStyle={{ color: '#cf1322' }}
                                prefix={<CloseCircleOutlined />} 
                            />
                        </Tooltip>
                    </Col>
                    <Col xs={12} sm={12} md={6}>
                        <Tooltip title="Delivery success rate">
                            <Statistic 
                                title="Success Rate" 
                                value={getSuccessRate()} 
                                suffix="%" 
                                precision={0}
                                valueStyle={{ 
                                    color: getSuccessRate() > 90 ? '#3f8600' : 
                                           getSuccessRate() > 75 ? '#faad14' : '#cf1322' 
                                }}
                                prefix={<ClockCircleOutlined />} 
                            />
                        </Tooltip>
                    </Col>
                </Row>
            )}
        </Card>
    );
};

export default NotificationMetrics;
